import { c as _c } from "react/compiler-runtime";
import React from "react";
const FavoritesIcon = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_4791_7668)"><path d="M14.5724 2.33463C13.6504 1.41255 12.4245 0.904785 11.1205 0.904785C9.96719 0.904785 8.87494 1.30202 7.99998 2.03167C7.12507 1.30202 6.03279 0.904785 4.87956 0.904785C3.57556 0.904785 2.34962 1.41259 1.42754 2.33463C-0.475847 4.23805 -0.475847 7.33518 1.42754 9.23866L6.7806 14.5917C7.10535 14.9164 7.53838 15.0952 8.00001 15.0952C8.46164 15.0952 8.89467 14.9164 9.21942 14.5917L14.5724 9.23866C16.4758 7.33518 16.4758 4.23802 14.5724 2.33463ZM13.9093 8.57557L8.55632 13.9286C8.40872 14.0762 8.21116 14.1574 8.00001 14.1574C7.78885 14.1574 7.5913 14.0762 7.44369 13.9286L2.09067 8.5756C0.552916 7.03772 0.552915 4.53551 2.09064 2.99773C2.8356 2.25276 3.82607 1.84252 4.87956 1.84252C5.93304 1.84252 6.92351 2.25276 7.66844 2.99769C7.8515 3.18081 8.14839 3.18081 8.33154 2.99769C9.0765 2.25273 10.067 1.84249 11.1205 1.84249C12.174 1.84249 13.1644 2.25273 13.9094 2.99766C15.4471 4.53551 15.4471 7.03772 13.9093 8.57557Z" fill="#F64C4C" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">{t0}<defs><clipPath id="clip0_4791_7668"><rect width="16" height="16" fill="white" /></clipPath></defs></svg></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default FavoritesIcon;